<script setup lang="ts">

</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <g clip-path="url(#clip0_9897_4001)">
      <path
        d="M6.27783 0.388184C9.44302 0.388289 12.0093 2.95441 12.0093 6.11963C12.0092 9.28476 9.44296 11.851 6.27783 11.8511C3.11262 11.8511 0.546492 9.28482 0.546387 6.11963C0.546387 2.95435 3.11255 0.388184 6.27783 0.388184Z"
        fill="black"
        stroke="currentColor"
      />
      <path
        d="M4.88257 5.85787L6.71345 7.6886M8.28288 5.07318L5.66726 7.68881"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9897_4001">
        <rect
          width="12.555"
          height="12.555"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped>

</style>